import FormInputText from './FormInputText'
export default FormInputText
